
import { SidebarProvider } from "@/components/ui/sidebar";
import { useIsMobile } from "@/hooks/use-mobile";

interface MainLayoutProps {
  children: React.ReactNode;
}

export const MainLayout = ({ children }: MainLayoutProps) => {
  const isMobile = useIsMobile();
  
  return (
    <SidebarProvider>
      <div className={`min-h-screen w-screen bg-[#1A1F2C] text-foreground flex overflow-hidden ${isMobile ? 'flex-col' : ''}`}>
        {children}
      </div>
    </SidebarProvider>
  );
};
